import type { TestProfile } from '../../../../types/testVendorRequest.types';

// Simple fake profile generator with 10 unique profiles
export const TEST_PROFILES: TestProfile[] = [
  {
    id: 'p1',
    name: 'Aiden Brooks',
    gender: 'male',
    age: 22,
    firstName: 'Aiden',
    lastName: 'Brooks',
    email: 'aiden.brooks@example.com',
    phone: '555-111-2222',
    address_1: '123 Ocean Blvd',
    city: 'San Diego',
    state: 'CA',
    zip: '92101',
    ip: '192.168.1.10',
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)'
  },
  {
    id: 'p2',
    name: 'Brooke Chen',
    gender: 'female',
    age: 38,
    firstName: 'Brooke',
    lastName: 'Chen',
    email: 'brooke.chen@example.com',
    phone: '555-333-4444',
    address_1: '456 Oak Ave',
    city: 'New York',
    state: 'NY',
    zip: '10001',
    ip: '10.0.0.23',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)'
  },
  {
    id: 'p3',
    name: 'Carlos Diaz',
    gender: 'male',
    age: 41,
    firstName: 'Carlos',
    lastName: 'Diaz',
    email: 'carlos.diaz@example.com',
    phone: '555-555-6666',
    address_1: '789 Pine Rd',
    city: 'Miami',
    state: 'FL',
    zip: '33101',
    ip: '172.16.0.5',
    userAgent: 'Mozilla/5.0 (X11; Linux x86_64)'
  },
  {
    id: 'p4',
    name: 'Dana Kapoor',
    gender: 'female',
    age: 27,
    firstName: 'Dana',
    lastName: 'Kapoor',
    email: 'dana.kapoor@example.com',
    phone: '555-777-8888',
    address_1: '101 Maple Blvd',
    city: 'Seattle',
    state: 'WA',
    zip: '98101',
    ip: '203.0.113.45',
    userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 16_1 like Mac OS X)'
  },
  {
    id: 'p5',
    name: 'Evan Lee',
    gender: 'male',
    age: 36,
    firstName: 'Evan',
    lastName: 'Lee',
    email: 'evan.lee@example.com',
    phone: '555-222-3333',
    address_1: '22 Cedar Ct',
    city: 'Newark',
    state: 'NJ',
    zip: '07102',
    ip: '198.51.100.9',
    userAgent: 'Mozilla/5.0 (Android 12; Pixel 6)'
  },
  {
    id: 'p6',
    name: 'Fatima Ali',
    gender: 'female',
    age: 62,
    firstName: 'Fatima',
    lastName: 'Ali',
    email: 'fatima.ali@example.com',
    phone: '555-444-5555',
    address_1: '88 Birch Ln',
    city: 'Denver',
    state: 'CO',
    zip: '80014',
    ip: '203.0.113.77',
    userAgent: 'Mozilla/5.0 (Windows NT 11.0; Win64; x64)'
  },
  {
    id: 'p7',
    name: 'Grace Müller',
    gender: 'female',
    age: 24,
    firstName: 'Grace',
    lastName: 'Müller',
    email: 'grace.mueller@example.com',
    phone: '555-666-7777',
    address_1: '5 Elm St',
    city: 'New York',
    state: 'NY',
    zip: '10001',
    ip: '192.0.2.56',
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 14_2)'
  },
  {
    id: 'p8',
    name: 'Hiro Tanaka',
    gender: 'male',
    age: 45,
    firstName: 'Hiro',
    lastName: 'Tanaka',
    email: 'hiro.tanaka@example.com',
    phone: '555-888-9999',
    address_1: '12 River Dr',
    city: 'San Jose',
    state: 'CA',
    zip: '95112',
    ip: '198.18.0.42',
    userAgent: 'Mozilla/5.0 (Linux; Android 13; SM-G998U)'
  },
  {
    id: 'p9',
    name: 'Isabella Rossi',
    gender: 'female',
    age: 35,
    firstName: 'Isabella',
    lastName: 'Rossi',
    email: 'isabella.rossi@example.com',
    phone: '555-000-1111',
    address_1: '300 Lakeview',
    city: 'Chicago',
    state: 'IL',
    zip: '60601',
    ip: '203.0.113.105',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)'
  },
  {
    id: 'p10',
    name: 'Jamal O\'Neal',
    gender: 'male',
    age: 68,
    firstName: 'Jamal',
    lastName: 'O\'Neal',
    email: 'jamal.oneal@example.com',
    phone: '555-121-2121',
    address_1: '77 Sunset Blvd',
    city: 'Los Angeles',
    state: 'CA',
    zip: '90001',
    ip: '192.0.2.88',
    userAgent: 'Mozilla/5.0 (iPad; CPU OS 16_3 like Mac OS X)'
  }
];

export const getProfileById = (id: string): TestProfile | null => TEST_PROFILES.find((p) => p.id === id) || null;

